export const EVENTS = {
  START_ONBOARDING: "start_onboarding",
  COMPLETE_ONBOARDING: "complete_onboarding",
};
